export enum IsoLocale {
  svSE = "sv-SE",
  svFI = "sv-FI",
  daDK = "da-DK",
  fiFI = "fi-FI",
  nbNO = "nb-NO",
  enGB = "en-GB",
  deDE = "de-DE",
  esES = "es-ES",
  esMX = "es-MX",
  ptBR = "pt-BR",
  nlNL = "nl-NL",
  frFR = "fr-FR",
  itIT = "it-IT",
  enUS = "en-US",
  esUS = "es-US",
}
